import { Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import dayjs from 'dayjs';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { inject, observer } from 'mobx-react';
import UserStore from 'src/stores/UserStore';

const useStyles = makeStyles({
    chip: {
        lineHeight: 'inherit',
        whiteSpace: 'pre-wrap',

        '& span': {
            whiteSpace: 'pre-wrap',
            padding: 0,
        },
    },
});

interface ProductAvailabilityLabelProps {
    inStock: boolean | null;
    availableFrom: string | null;
    stockQuantity?: number | null;
    user?: typeof UserStore.Type;
}

const ProductAvailabilityLabel = inject('user')(observer(({
    inStock,
    availableFrom,
    stockQuantity = 0,
    user,
}: ProductAvailabilityLabelProps) => {
    const classes = useStyles();

    let detailedStock = '';
    if (user?.impersonate !== null) {
        const intl = useIntl();
        detailedStock = `${intl.formatMessage({ id: 'status.inStock' })}: ${stockQuantity}`;
    }

    return (
        <FormattedMessage id={inStock ? 'status.inStock' : !availableFrom ? 'status.Unavailable' : 'status.outOfStock'}>
            {text => (
                <Chip
                    className={classes.chip}
                    data-testid="product-availability-badge"
                    label={
                        !inStock
                            ? `${text} ${availableFrom ? dayjs(availableFrom).format('DD/MM/YYYY') : ''}`
                            : `${detailedStock || text}`
                    }
                />
            )}
        </FormattedMessage>
    );
}));

export default ProductAvailabilityLabel;
